import { CatalogVariantFragmentFragment } from '@notino/shared/definitions/types';

import { useResolvedVoucherDiscount } from '../VoucherDiscount/useResolvedVoucherDiscount';
import { isConditionalDiscount } from '../VoucherDiscount/utils';

export const usePriceWithVoucher = ({
  price,
  attributes,
}: {
  price: CatalogVariantFragmentFragment['price'];
  attributes: unknown;
}) => {
  const voucherDiscount = useResolvedVoucherDiscount({ attributes });
  if (!voucherDiscount) {
    return price;
  }

  if (isConditionalDiscount(voucherDiscount)) {
    const fulfilledCondition = voucherDiscount.discountConditions.filter(
      ({ productMeetsCondition }) => productMeetsCondition
    );

    const conditionalMinPrice = Math.min(
      ...fulfilledCondition.map(({ discountedPrice }) => discountedPrice)
    );

    return fulfilledCondition.length > 0
      ? { ...price, value: conditionalMinPrice }
      : price;
  }

  return { ...price, value: voucherDiscount.discountedPrice };
};
